<template>
  <div class="card">
    <h1>Ordens de Serviço | LG</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>
    <LgCreateFromPat
        :showForm="createFromPatForm"
        v-on:cancel="createFromPatForm= false"
        v-on:serviceOrderCreated="serviceOrderCreated"
      />
    <Sidebar
      class="p-sidebar-md"
      :dismissable="false"
      position="right"
      :visible.sync="showSidebar"
      @hide="
        () => {
          showSidebar = false;
          serviceOrder = null;
        }
      "
    >
      <template #footer>
        <div class="flex items-center gap-2">
          <Button
            label="Account"
            icon="pi pi-user"
            class="flex-auto"
            outlined
          ></Button>
          <Button
            label="Logout"
            icon="pi pi-sign-out"
            class="flex-auto"
            severity="danger"
            text
          ></Button>
        </div>
      </template>
      <template #header>
        <div class="p-d-flex p-jc-between p-ai-center">
          <h3>Ordem de Serviço {{ serviceOrder.service_receipt_no }}</h3>
        </div>
      </template>
      <DetailLG
        :serviceOrder="serviceOrder"
        v-on:createPatAcceptService="createPatAcceptServiceOK"
      />
    </Sidebar>
    <div class="p-grid p-fluid dashboard p-jc-center p-mb-3">
      <W4MstreakIndicators
        :indicators="streakIndicators"
        :loader="indicatorLoading"
        v-on:W4MstreakIndicatorsClick="streakIndicatorsClick"
      />
    </div>
    <div style="height: 65vh">
      <DataTable
        :value="serviceOrderList"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
        :autoLayout="true"
        stripedRows
        :lazy="true"
        :totalRecords="totalRecords"
        @page="fetchData"
        @sort="fetchData"
        @filter="fetchData"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
      >
        <template #empty> Não existem ordens de serviço. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <template #header>
          <div class="table-header">
            <Button
              class="p-mr-2"
              icon="pi pi-th-large"
              label="Verificar se existem novas Ordens de Serviço"
              @click="getServiceOrderToLGApi"
              v-if="can('getServiceOrderToLGApi')"
            />
            <Button
              icon="pi pi-plus"
              @click="createFromPatForm = true"
            />
          </div>
        </template>
        <Column
          field="service_receipt_no"
          header="Ref"
          sortable
          filterField="service_receipt_no"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="
                () => {
                  serviceOrder = slotProps.data;
                  showSidebar = true;
                }
              "
              >{{ slotProps.data.service_receipt_no }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por ref"
            />
          </template>
        </Column>
        <Column
          field="receipt_date"
          header="Data"
          sortable
          filterField="receipt_date"
        >
          <template #filter="{ filterModel, filterCallback }">
            <v-date-picker
              mode="date"
              v-model="filterModel.value"
              @input="onDateFilterChange($event, filterModel, filterCallback)"
              :masks="{
                input: 'DD-MM-YYYY',
                data: 'DD-MM-YYYY'
              }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-column-filter p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
          </template>
        </Column>
        <Column
          field="brand_code"
          header="Marca"
          sortable
          filterField="brand_code"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por marca"
            />
          </template>
        </Column>
        <Column
          field="model_code"
          header="Modelo"
          sortable
          filterField="model_code"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por modelo"
            />
          </template>
        </Column>
        <Column
          field="contact_name"
          header="Cliente"
          sortable
          filterField="contact_name"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por cliente"
            />
          </template>
        </Column>
        <Column
          field="priority_flag"
          header="Prioridade"
          sortable
          filterField="priority_flag"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por prioridade"
            />
          </template>
        </Column>
        <Column field="pat_id" header="PAT" sortable filterField="pat_id">
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por PAT"
            />
          </template>
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="goToPat(slotProps.data.pat_id)">
                {{ slotProps.data.pat_id }}
            </span>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import W4MstreakIndicators from "../components/W4Mstreak/W4MstreakIndicators.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import serviceOrdersService from "../services/serviceOrders.service";
import DetailLG from "../components/serviceOrders/DetailLG.vue";
import LgCreateFromPat from "../components/serviceOrders/LgCreateFromPat.vue";
import DebouncedFilterInput from "../components/elements/DebouncedFilterInput.vue";
import { FilterMatchMode } from "primevue/api/";
export default {
  name: "ServiceOrdersLG",
  components: {
    W4MstreakIndicators,
    DetailLG,
    LgCreateFromPat,
    DebouncedFilterInput,
  },
  data() {
    return {
      loading: false,
      createFromPatForm: false,
      showSidebar: false,
      indicatorLoading: false,
      currentState: {},
      serviceOrderList: [],
      totalRecords: 0,
      perPage: 20,
      serviceOrder: null,
      filters: {
        service_receipt_no: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
        receipt_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        brand_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        model_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        contact_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        priority_flag: { value: null, matchMode: FilterMatchMode.CONTAINS },
        pat_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async created() {
    await this.initStreakIndicators();
    this.loading = false;
  },
  methods: {
    async initStreakIndicators() {
      this.indicatorLoading = true;
      this.streakIndicators = [
        {
          title: "Aceites",
          color: "#20d077",
          counter: 0,
        },
        {
          title: "Por Aceitar",
          counter: 0,
        },
        {
          title: "Sem Pat",
          counter: 0,
        },
      ];
      this.streakIndicators = [
        {
          title: "Aceites",
          color: "#20d077",
          counter: await serviceOrdersService.countLgServiceOrdersAccepted(),
        },
        {
          title: "Por Aceitar",
          counter: await serviceOrdersService.countLgServiceOrdersToAccept(),
        },
        {
          title: "Sem Pat",
          counter: await serviceOrdersService.countLgServiceOrdersWithoutPat(),
        },
      ];
      this.indicatorLoading = false;

      if (this.currentState != {}) {
        return this.streakIndicatorsClick(this.currentState);
      }
    },
    async streakIndicatorsClick(info) {
      this.currentState = info;
      this.fetchData();
    },
    onDateFilterChange(date, filterModel, filterCallback) {
      if (date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        filterModel.value = `${year}-${month}-${day}`;
      } else {
        filterModel.value = null;
      }

      filterCallback();
    },
    buildQueryParams(page = 1) {
      const params = new URLSearchParams();
      params.append('page', page);

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          params.append(`filters[${key}]`, filter.value);
        }
      }

      return params;
    },
    async fetchData(event = {}) {
      if (!this.currentState.indicatorName) return;

      this.loading = true;
      const page = event.page != null ? event.page + 1 : 1;
      const params = this.buildQueryParams(page);
      params.append('per_page', event.rows || this.perPage);

      let response = null;
      if (this.currentState.indicatorName == "Aceites") {
        response = await serviceOrdersService.getLgServiceOrdersAccepted(params);
      } else if (this.currentState.indicatorName == "Por Aceitar") {
        response = await serviceOrdersService.getLgServiceOrdersToAccept(params);
      } else if (this.currentState.indicatorName == "Sem Pat") {
        response = await serviceOrdersService.getLgServiceOrdersWithoutPat(params);
      }

      if (response) {
        this.serviceOrderList = response.data;
        this.totalRecords = response.total;
      }
      this.loading = false;
    },
    createPatAcceptServiceOK() {
      this.showSidebar = false;
      return this.initStreakIndicators();
    },
    getServiceOrderToLGApi() {
      this.loading = true;
      return serviceOrdersService.getLgServiceOrdersToAPI().then((response) => {
        this.loading = false;
        if (
          response.jobsError.length == 0 &&
          response.serviceOrders.length == 0
        ) {
          return this.$toast.add({
            severity: "success",
            summary: `Não existem novas ordens de serviço`,
            detail: "",
            life: 3000,
          });
        }

        if (response.serviceOrders.length > 0) {
          return this.$toast.add({
            severity: "success",
            summary: `Ordens de Serviço importadas com sucesso`,
            detail: `Foram importadas com sucesso ${response.serviceOrders.length} ordens de serviço`,
            life: 3000,
          });
        }
        if (response.jobsError.length > 0) {
          return this.$toast.add({
            severity: "warn",
            summary: `Ordens de Serviço com erros`,
            detail: `${response.serviceOrders.length} ordens de serviço contêm erros`,
            life: 3000,
          });
        }
        return this.initStreakIndicators();
      });
    },
    serviceOrderCreated() {
      this.createFromPatForm = false;
      this.initStreakIndicators();
    },
    goToPat(patId) {
      this.$router.push(`/pats/${patId}`);
    },
  },
};
</script>
<style>
.p-sidebar-header-content {
  width: 100% !important;
}
</style>
